<template>
  <v-container>
    <section id="title-and-cpoy">
      <v-container class="text-center">
        <div v-if="isDebug">
          【デバッグモード】
          <div v-if="!isMobileDevice()">
            <div>PCで表示</div>
          </div>
          <div v-if="isMobileDevice()">
            <div>モバイルで表示</div>
          </div>
        </div>
        <h1 class="display-1 font-weight-bold">
          {{title}}
        </h1>
      </v-container>
      <v-responsive
        class="text-center mx-auto title font-weight-bold mb-5"
        max-width="1200"
      >
        {{description}}
      </v-responsive>
    </section>

    <section id="about">
      <v-container class="text-center">
        <h2 class="font-weight mb-3">
          About
        </h2>
      </v-container>

      <div v-if="!isMobileDevice()">
        <v-row>
          <v-col>
            <v-responsive
              class="text-center font-weight mb-10"
            >
              <nl2br tag="p" :text="about.description" />
            </v-responsive>
          </v-col>
        </v-row>
      </div>

      <div v-if="isMobileDevice()">
        <v-row>
          <v-container>
            <v-responsive
            >
                <div class="font-weight mb-10">
                  {{about.description}}
                </div>
            </v-responsive>
          </v-container>
        </v-row>
      </div>
    </section>

    <section id="concept">
      <v-container class="text-center">
        <h2 class="font-weight mb-3">
          Project Concept
        </h2>
      </v-container>

      <div v-if="!isMobileDevice()">
        <v-row>
          <v-col>
            <v-container class="text-center">
              <v-responsive
                class="mx-auto headline font-weight-bold mb-3"
              >
                {{concept.title}}
              </v-responsive>
              <v-responsive
                class="mx-auto headline font-weight mb-3"
              >
                {{concept.name}}
              </v-responsive>
              <v-responsive
                class="font-weight mb-10"
              >
                <nl2br tag="p" :text="concept.description" />
              </v-responsive>
            </v-container>
          </v-col>
        </v-row>
      </div>

      <div v-if="isMobileDevice()">
        <v-row>
          <v-container>
            <v-responsive
            >
                <div class="text-center mx-auto headline font-weight-bold mb-3">
                  {{concept.title}}
                </div>
                <div class="text-center mx-auto headline font-weight mb-3">
                  {{concept.name}}
                </div>
                <div class="font-weight mb-10">
                  {{concept.description}}
                </div>
            </v-responsive>
          </v-container>
        </v-row>
      </div>
    </section>

    <section id="contents">
      <v-container class="text-center">
        <h2 class="font-weight mb-3">
          Contents
        </h2>
      </v-container>

      <div v-if="!isMobileDevice()">
        <v-row>
          <v-col>
            <v-img
              :width="'calc(40vw)'"
              :src="contents.thumbnail"
            >
            </v-img>
          </v-col>
          <v-col>
            <v-responsive
              class="mx-auto headline font-weight"
            >
              {{contents.title}}
            </v-responsive>
            <v-responsive
              class="mx-auto headline font-weight mb-3"
            >
              {{contents.name}}
            </v-responsive>
            <v-responsive
              class="font-weight-light mb-3"
              max-width="1200"
            >
              <nl2br tag="p" :text="contents.description" />
            </v-responsive>
          </v-col>
        </v-row>
        <div class="py-8"></div>
      </div>

      <div v-if="isMobileDevice()">
        <v-row>
          <v-container class="text-center">
            <v-img
              class="mb-3"
              :width="'calc(100vw)'"
              :src="contents.thumbnail"
            >
            </v-img>
            <v-responsive>
              <v-container class="text-left">
                <div class="headline font-weight">
                  {{contents.title}}
                </div>
                <div class="headline font-weight mb-3">
                  {{contents.name}}
                </div>
                <div class="font-weight mb-3">
                  {{contents.description}}
                </div>
              </v-container>
            </v-responsive>
          </v-container>
        </v-row>
      </div>
    </section>

    <section id="store">
      <v-container class="text-center mt-10">
        <v-btn
          color="white"
          :href="store_url"
          outlined
          width="300"
          height="50"
          target="_blank"
        >
          <span class="headline font-weight-bold">
            STORE
          </span>
        </v-btn>
      </v-container>
    </section>

    <section id="contact">
      <v-container class="text-center mt-10">
        <v-btn
          color="white"
          :href="contact_url"
          outlined
          width="300"
          height="50"
          target="_blank"
        >
          <span class="headline font-weight-bold">
            CONTACT
          </span>
        </v-btn>
      </v-container>

      <div class="py-8"></div>
    </section>

    <section id="corporate-information">
      <v-container class="text-center">
        <v-responsive
            class="mx-auto font-weight"
            max-width="250"
        >
          <a
            :href="corporate_url"
            target="_blank"
          >
            <v-img
              :src="corporate_logo"
            >
            </v-img>
          </a>
          <div class="py-2"></div>

        </v-responsive>
      </v-container>

      <div class="py-16"></div>
    </section>

    <section id="links">

      <div v-if="!isMobileDevice()">
        <v-container class="text-center">
          <v-responsive
            class="mx-auto"
            max-width="400"
          >
            <v-row align="center" justify="center">
              <v-col
                v-for="({icon, url}, i) in links"
                :key="i"
              >
                <a
                  :href="url"
                  target="_blank"
                >
                  <v-img
                    width="40"
                    :src="icon"
                  >
                  </v-img>
                </a>
              </v-col>
            </v-row>
          </v-responsive>
        </v-container>
      </div>

      <div v-if="isMobileDevice()">
        <v-container class="text-center">
          <v-responsive
            class="mx-auto"
            max-width="400"
          >
            <v-row align="center" justify="center">
              <v-col
                v-for="({icon, url}, i) in links"
                :key="i"
              >
                <a
                  :href="url"
                  target="_blank"
                >
                  <v-img
                    width="30"
                    :src="icon"
                  >
                  </v-img>
                </a>
              </v-col>
            </v-row>
          </v-responsive>
        </v-container>
      </div>

    </section>
  </v-container>
</template>

<script>
  import isMobile from "ismobilejs";

  export default {
    name: 'NakedLP',

    data: () => ({
      // タイトル
      title : '',

      // ページの詳細
      description : '',

      // 会社ロゴ
      corporate_logo : './Images/nakedinc_logo.png',

      // 会社ロゴからの接続先
      corporate_url : 'https://naked.co.jp/',

      // お問い合わせの接続先
      store_url : 'https://naked-inc.stores.jp/',

      // お問い合わせの接続先
      contact_url : 'https://naked.co.jp/contact/',




    // About
    //
    // thumbnail => サムネイル画像
    // title => タイトル
    // description => 詳細説明
    about : {
        thumbnail : './Images/RM.jpg',
        title : 'ARTIST',
        name : 'Ryotaro Muramatsu',
        description :
          ' NAKED OCEANとは、命なきものにクリエイティブアイデアと先端のテクノロジーを使い命を吹き込み、\r\n'
          + '生命ではないものに対して感じる生命の儚さ、美しさ、力強さに出会う生命そのものが変化し続ける体感型の「海洋体験」。\r\n'
          + '本物の水や触感、没入空間などを軸に リアルとバーチャルを超えた体験を創り出すプロジェクトです。\r\n'
          + '「深海」という人間が決して踏み込むことのできない未知の領域など、\r\n'
          + '未だ解明されていない海洋世界をデジタルだからこそ体感できる新しいエンタテインメント体験として世界各国で注目を集めています。\r\n'
    },

    // Project Concept
    //
    // thumbnail => サムネイル画像
    // title => タイトル
    // description => 詳細説明
    concept : {
        thumbnail : '',
        title : 'LIFE',
        name : '生命の起源「海」',
        description :
        ' デジタルによって生み出された海や生き物たちが\r\n'
      + 'テクノロジーによって反応するときに覚える、\r\n'
      + 'まるでそこに「生命」が存在しているかのような感覚。\r\n'
      + '\r\n'
      + '生命とか何か。\r\n'
      + '存在するとはどういうことなのか。\r\n'
      + '\r\n'
      + 'リアルとヴァーチャルの交錯が加速する今、\r\n'
      + 'ヴァーチャルにも本物のような感覚が伴うようになるこれから、\r\n'
      + '〈存在〉というものはどのように定義されていくのか。\r\n'
      + '\r\n'
      + '生命の起源であり、生態系を司る要素の一つである海の神秘をテーマに、\r\n'
      + '海の知育も含め、持続可能な社会に繋げるクリエイティブを行い、\r\n'
      + '世の中に発信していきます。',
          },

    // コンテンツ情報
    //
    // thumbnail => サムネイル画像
    // title => タイトル
    // description => 詳細説明
    contents : {
        thumbnail : './Images/contents1.JPG',
        title : 'NAKED×JAMSTEC初コラボ！',
        name : 'おうちで楽しみながら深海世界が学べる',
        description :
          'NAKED OCEANのメインショー作品として、日本全国に留まらず、世界各国でも好評を博する「PARADISE」。\r\n'
          + '「PARADISE」を深海の世界を旅するファンタジーショーとして楽しめるVR商品『NAKED OCEAN』として発売いたします。\r\n'
          + 'また海と地球の研究所、海洋研究開発機構（JAMSTEC）の協力のもと、ショーに登場する深海生物や海の不思議について学べる解説書がセットに。おうちでVRを楽しみながら、深海世界について学びませんか。\r\n'
    },




      // 各種SNSのリンク
      //
      // icon => アイコン
      // url => リンク先URL
      links : [
          {
            icon : './Images/icon_facebook.png',
            url : 'https://www.facebook.com/NAKEDINC.official/'
          },
          {
            icon : './Images/icon_twitter.png',
            url : 'https://twitter.com/naked_staff'
          },
          {
            icon : './Images/icon_instagram.png',
            url : 'https://www.instagram.com/naked_inc/'
          },
          {
            icon : './Images/icon_line.png',
            url : 'https://line.me/R/ti/p/%40muramatsuryotaro'
          },
          {
            icon : './Images/icon_youtube.png',
            url : 'https://www.youtube.com/channel/UCyhXNMOGaP1hOIZnq7PGfuw'
          },
      ],

      // いったん以下は使わない
      //windowWidth: window.innerWidth+'px',

      // PCとモバイルを切り替えるためのもの、消さないように
      isMobile,

      isMobileDevice: function() {
        if (isMobile().any) {
            return true;
        }
        return false;
      },

      // デバッグモード判定
      isDebug : false
    }),
  }
</script>
